@if (maintenanceMode) {
<app-maintenance></app-maintenance>
} @else {
<app-header></app-header>
<main class="app-main">
  <router-outlet />
</main>
<app-footer></app-footer>
<app-whatsapp-fab></app-whatsapp-fab>
<app-scroll-top></app-scroll-top>
@if (!disableChatBubble) {
<app-ollama-assistant></app-ollama-assistant>
}
}